export default {
  name: 'booster',
  delay: 1000,

  componentDidMount () {
    setTimeout(() => {
      this.el.classList.add('has-transition')
    }, this.delay)
  },
}
